import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <Container sx={{ textAlign: "center", mt: 10 }}>
      <Typography variant="h3" color="primary" fontWeight="bold">
        Welcome to Virtual Gift
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>
        Create and share a personalized virtual birthday gift.
      </Typography>
      <Button
        component={Link}
        to="/create"
        variant="contained"
        color="primary"
        sx={{ mt: 4 }}
      >
        Create a Gift
      </Button>
    </Container>
  );
};

export default Home;
